export default "__VITE_ASSET__lgkoSVHg__"